export default __webpack_public_path__ + "static/media/footer2.4893e3d7.jpeg";